module.exports = __webpack_public_path__ + "static/media/PSV.7b611107.jpg";